import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Activity, Group, Profile, UserInfo } from '@tekman/onmat/models';
import { EnvironmentService } from '@tekman/onmat/service/generic';
import { GroupsFacade } from '@tekman/onmat/store/group';
import { ProfileFacade } from '@tekman/onmat/store/profile';
import { SubSink } from '@tekman/shared/utils';
import { zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from '@tekman/shared/service';

@Component({
  selector: 'tekman-typeform',
  templateUrl: './typeform.component.html',
  styleUrls: ['./typeform.component.scss'],
})
export class TypeformComponent implements OnInit, OnDestroy {
  @Input() activity: Activity;
  hiddenFields: any;
  subscription: SubSink = new SubSink();

  constructor(
    private readonly environment: EnvironmentService,
    private readonly profileFacade: ProfileFacade,
    private localStorage: StorageService,
    private groupFacade: GroupsFacade
  ) {}

  ngOnInit(): void {
    this.subscription.sink = zip(
      this.profileFacade.profile$,
      this.profileFacade.userInfo$,
      this.groupFacade.selectedGroup$,
      this.groupFacade.groups$
    )
      .pipe(map(([profile, userInfo, groupSelected, groups]) => this.init(profile, userInfo, groupSelected.id, groups)))
      .subscribe();
  }

  init(profile: Profile, userInfo: UserInfo, selectedGroupId: string, groups: Group[]) {
    this.hiddenFields = {
      activity_id: this.activity.id,
      typology: this.activity.typology.title,
      activity: this.activity.title,
      unit: this.activity.step.title,
      schoolid: profile.schoolId,
      name: profile.fullName,
      email: profile.email,
      region: this.localStorage.selectedAcademicYear,
      course: groups.find(group => group.id === selectedGroupId)?.courseName,
      env: this.environment.settings?.typeform?.env,
    };
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
